"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiInputBaseOverrides = void 0;
var createMuiInputBaseOverrides = function (_a) {
    var typography = _a.typography, spacing = _a.spacing, palette = _a.palette;
    return ({
        root: {
            fontSize: typography.pxToRem(14),
            letterSpacing: "0.014em",
            lineHeight: 1.43,
            "&$disabled": {
                color: undefined,
                opacity: palette.action.disabledOpacity,
            },
        },
        multiline: {
            padding: 0,
        },
        input: {
            "&[type='search']::-webkit-search-cancel-button": {
                display: "none",
            },
            boxSizing: "border-box",
            height: spacing(12),
            // Regular without label
            padding: spacing(4),
            // Regular with label
            "label + $formControl > &": {
                paddingTop: spacing(6),
                paddingBottom: spacing(2),
            },
            "&::placeholder": {
                opacity: 0.7,
                color: palette.text.secondary,
                "$disabled&": {
                    color: palette.text.disabled,
                },
            },
        },
        //small size
        inputMarginDense: {
            height: spacing(8),
            padding: spacing(2),
            "label + $formControl > &": {
                padding: spacing(2),
            },
        },
        inputMultiline: {
            // Multiline without label
            padding: spacing(3, 4),
            "&$inputMarginDense": {
                padding: spacing(0, 2),
            },
            // Multiline with label
            "label + $formControl > &": {
                marginTop: spacing(6),
                padding: spacing(0, 4, 2),
                "&$inputMarginDense": {
                    marginTop: spacing(0),
                    padding: spacing(0, 2),
                },
            },
        },
    });
};
exports.createMuiInputBaseOverrides = createMuiInputBaseOverrides;
//# sourceMappingURL=MuiInputBase.js.map